import React from 'react';

export default function NoPermission() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-2xl font-black text-slate-900">No Permission</h1>
        <p className="mt-3 text-slate-600">
          You dont have any permission to view this page please contact the adminnistator
        </p>
      </div>
    </div>
  );
}
